import { ModalStore } from 'ui/base/modal/modal_store';
import { BooleanStore } from 'ui/base/input';
import { action, computed, observable } from 'mobx';
import { ORDERED_DIRECTIONS, Direction } from 'assets/enums/directions/directions';

export class DirectionStore {
  @observable.deep values: Record<Direction, boolean>;
  workspace: Record<Direction, BooleanStore>;

  modal: ModalStore;

  constructor(initial: Record<Direction, boolean>) {
    this.values = {
      [Direction.OUTBOUND]: initial[Direction.OUTBOUND],
      [Direction.INBOUND]: initial[Direction.INBOUND],
      [Direction.LOCAL]: initial[Direction.LOCAL],
    };

    this.workspace = {
      [Direction.OUTBOUND]: new BooleanStore(this.values[Direction.OUTBOUND]),
      [Direction.INBOUND]: new BooleanStore(this.values[Direction.INBOUND]),
      [Direction.LOCAL]: new BooleanStore(this.values[Direction.LOCAL]),
    };

    this.modal = new ModalStore(false);
  }

  // This triggers a reload from the stored values to the workspace
  // This is best used before opening the modal
  @action.bound
  reloadWorkspace(): void {
    Object.entries(this.workspace).forEach(([dir, store]) => {
      store.value = this.values[dir as Direction];
    });
  }

  // This triggers a commit to the workspace from the stored values
  // Best used before closing and saving the modal
  @action.bound
  commitWorkspace(): void {
    Object.entries(this.workspace).forEach(([dir, store]) => {
      this.values[dir as Direction] = store.value;
    });
  }

  @computed get arrayValue(): Direction[] {
    return ORDERED_DIRECTIONS.filter((dir) => this.values[dir] === true);
  }

  @computed get workspaceHasChecked(): boolean {
    return Object.values(this.workspace).some((store) => store.value);
  }
}
